/**
 * URLからパラメータを抽出する
 * @param path URL
 * @return クライアントID、部署ID、現在のパス
 */
export function toDepartmentPath(path: string) {
  const split = path.split("/");
  const clientId = split[2];
  const departmentId = split[4];
  const activePath = split[5] == "employees" ? split[5] : split.slice(5).join("/");
  return {
    clientId: clientId,
    departmentId: departmentId,
    activePath: activePath
  };
}
/**
 * URLからパラメータを抽出する
 * @param path URL
 * @return クライアントID、現在のパス
 */
export function toClientPath(path: string) {
  const split = path.split("/");
  return {
    clientId: split[2],
    activePath: split.slice(3).join("/")
  };
}
